// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number-selector-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
}

.number-selector-scroll-panel {
    flex: 1;
    justify-items: center;
    overflow-x: auto;
    scroll-behavior: smooth;
}

.number-selector-bar {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 60px;
    padding: 10px;
    width: fit-content;
}

    .number-selector-bar > .number-selector-circle {
        margin-left: 0px;
    }

        .number-selector-bar > .number-selector-circle ~ .number-selector-circle {
            margin-left: 32px;
        }

@media (max-width: 768px) {
    .number-selector-bar {
        margin-left: 60px;
    }
}

    .number-selector-bar-indicator {
        position: absolute;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        left: 10px;
        right: 10px;
        height: 8px;
        z-index: 0;
    }

    .number-selector-circle-container {
        margin-right: 60px;
    }

    .number-selector-circle {
        min-width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 0 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        cursor: pointer;
        user-select: none;
        z-index: 1;
    }

    .number-selector-button {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        padding: 0 12px;
        user-select: none;
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/Selectors/css/NumberSelector.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;IAEI;QACI,gBAAgB;IACpB;;QAEI;YACI,iBAAiB;QACrB;;AAER;IACI;QACI,iBAAiB;IACrB;AACJ;;IAEI;QACI,kBAAkB;QAClB,aAAa;QACb,eAAe;QACf,qBAAqB;QACrB,UAAU;QACV,WAAW;QACX,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,eAAe;QACf,eAAe;QACf,iBAAiB;IACrB","sourcesContent":[".number-selector-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.number-selector-scroll-panel {\r\n    flex: 1;\r\n    justify-items: center;\r\n    overflow-x: auto;\r\n    scroll-behavior: smooth;\r\n}\r\n\r\n.number-selector-bar {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    height: 60px;\r\n    padding: 10px;\r\n    width: fit-content;\r\n}\r\n\r\n    .number-selector-bar > .number-selector-circle {\r\n        margin-left: 0px;\r\n    }\r\n\r\n        .number-selector-bar > .number-selector-circle ~ .number-selector-circle {\r\n            margin-left: 32px;\r\n        }\r\n\r\n@media (max-width: 768px) {\r\n    .number-selector-bar {\r\n        margin-left: 60px;\r\n    }\r\n}\r\n\r\n    .number-selector-bar-indicator {\r\n        position: absolute;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-content: center;\r\n        left: 10px;\r\n        right: 10px;\r\n        height: 8px;\r\n        z-index: 0;\r\n    }\r\n\r\n    .number-selector-circle-container {\r\n        margin-right: 60px;\r\n    }\r\n\r\n    .number-selector-circle {\r\n        min-width: 40px;\r\n        height: 40px;\r\n        border-radius: 50%;\r\n        margin: 0 0px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-weight: bold;\r\n        cursor: pointer;\r\n        user-select: none;\r\n        z-index: 1;\r\n    }\r\n\r\n    .number-selector-button {\r\n        background: none;\r\n        border: none;\r\n        font-size: 24px;\r\n        cursor: pointer;\r\n        padding: 0 12px;\r\n        user-select: none;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
